import * as THREE from "three";
import Experience from "./Experience.js";
import { XRControllerModelFactory } from "three/examples/jsm/webxr/XRControllerModelFactory.js";

export default class Controllers {
  constructor() {
    this.experience = new Experience();
    this.canvas = this.experience.canvas;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.renderer = this.experience.renderer;

    this.controller1 = this.renderer.instance.xr.getController(0);
    // audio.play();
    const onSelectStart = function () {
      // audio.play();
    };
    this.controller1.addEventListener("selectstart", onSelectStart);
    // this.controller1.addEventListener( 'selectend', onSelectEnd );
    this.scene.add(this.controller1);

    this.controller2 = this.renderer.instance.xr.getController(1);
    this.controller2.addEventListener("selectstart", onSelectStart);
    // this.controller2.addEventListener( 'selectend', onSelectEnd );
    this.scene.add(this.controller2);

    this.controllerModelFactory = new XRControllerModelFactory();

    this.controllerGrip1 = this.renderer.instance.xr.getControllerGrip(0);
    this.controllerGrip1.add(
      this.controllerModelFactory.createControllerModel(this.controllerGrip1)
    );
    this.scene.add(this.controllerGrip1);

    this.controllerGrip2 = this.renderer.instance.xr.getControllerGrip(1);
    this.controllerGrip2.add(
      this.controllerModelFactory.createControllerModel(this.controllerGrip2)
    );
    this.scene.add(this.controllerGrip2);
  }

  setInstance() {}

  resize() {}

  update() {}
}
